import React, { ReactNode } from 'react';

import * as styles from './visually-hidden.scss';

interface VisuallyHiddenProps {
  children: ReactNode;
}

/**
 * Renders content that is visually hidden but remains accessible to screen readers.
 * Use this to provide accessible labels for elements that should not display visible text
 * (e.g. empty table headers, icon-only buttons etc).
 */
export const VisuallyHidden = ({ children }: VisuallyHiddenProps) => (
  <span className={styles.visuallyHidden}>{children}</span>
);
